import styled from 'styled-components';

const SupportTitleText = styled.div`
  font-size: 14px;
  margin-bottom: 16px;
  margin-top: 25px;
`;

export default SupportTitleText;
